import 'jquery';
import 'jquery-ui-dist/jquery-ui';
import 'moment-timezone';
import 'bootstrap';
import 'bootstrap-daterangepicker';
import 'jquery-popup-overlay';
import 'jquery-sortable';
import 'jquery-validation';

import 'fullcalendar';
import '@vendor/fullcalendar/locale';

import 'jstree';

import 'highcharts';
import 'highcharts/highcharts-more';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/offline-exporting';
import 'highcharts/modules/heatmap';
import 'highcharts/modules/boost';
import 'highcharts/modules/annotations';
import jsPDF from 'jspdf';
import svg2pdf from 'svg2pdf.js';
import BrowserDetectionService from '@common/browserDetection/BrowserDetectionService';
import EventService from '@common/event/EventService';
import TimeInMilliseconds from '@common/time/TimeInMilliseconds';
import EvaluationEvent from './vcom/events/EvaluationEvent';
import TechnicalDataEvent from './vcom/events/TechnicalDataEvent';

window.VCOM = {};
window.jsPDF = jsPDF;
window.svg2pdf = svg2pdf;
window.EventService = EventService;
window.BrowserDetectionService = BrowserDetectionService;
window.EvaluationEvent = EvaluationEvent;
window.TechnicalDataEvent = TechnicalDataEvent;

$.ajaxSetup({ timeout: TimeInMilliseconds.MINUTE * 4 });

// Prevent naming conflicts between jQuery UI and Bootstrap
const bootstrapButton = $.fn.button.noConflict();
$.fn.bootstrapButton = bootstrapButton;
const bootstrapTooltip = $.fn.tooltip.noConflict();
$.fn.bootstrapTooltip = bootstrapTooltip;
